import { Box, Button, Modal, Grid, Typography } from "@mui/material";
import { changeActive } from "services/nodejs.service";

const channel_map: any = {
  0: "APP POR PROGRAMA",
  1: "APP BRAZIL",
  2: "APP BOTNAR",
  50: "AFINIAPP",
  100: "WHATSAPP PROGRAMA",
  101: "WHATSAPP BRAZIL",
  102: "WHATSAPP BOTNAR",
};

const frequencyMap = [
  "1 vez a la semana" ,
  "1 ves cada 2 semanas" ,
  "cada inicio de mes" ,
  "al fin de mes" ,
];

function PushPauseModal({ pushToModify, close, visible, refresh }: any) {
  const changeIfActive = async () => {
    console.log(pushToModify)
    await changeActive({ id: pushToModify.id, active:!pushToModify.active });
    await refresh();
    close();
  };
  

  return (
    <Modal open={visible}>
      <Box sx={minorStyle}>
        <Grid container flexDirection={"row"}>
          <Grid container p={1}>
            <Grid item>
              <Typography variant="h6" color={"black"}>
                Seguro que quieres {pushToModify.active?"activar":"desactivar"} el evento:
              </Typography>
              <Typography variant="h6" color={"black"}>
                Nombre: {pushToModify.name}
              </Typography>
              <Typography variant="h6" color={"black"}>
                Canal: {channel_map[pushToModify.channel]}
              </Typography>
              <Typography variant="h6" color={"black"}>
                Frecuencia: {frequencyMap[pushToModify.frequency]}
              </Typography>
              <Typography variant="h6" color={"black"}>
                Recuerda que si una push por evento esta desactivdada NO se van a enviar esas pushes
              </Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={6} p={1}>
              <Button
                variant="contained"
                fullWidth
                onClick={() => changeIfActive()}
              >
                Si
              </Button>
            </Grid>
            <Grid item xs={6} p={1}>
              <Button variant="contained" fullWidth onClick={() => close()}>
                Cerrar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

const minorStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  bgcolor: "white",
  p: 4,
  display: "flex",
  flexDirection: "column",
  transform: "translate(-50%, -50%)",
  // minWidth:'70%'
};

export { PushPauseModal };
